module.exports = __webpack_public_path__ + "img/propertyappLogo.e6681cf5.png";